// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAlertsEwiErrorRound_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75C8.8995 0.75 11.25 3.10051 11.25 6Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.94462 9.00455L2.99487 4.0548L4.05553 2.99414L9.00528 7.94389L7.94462 9.00455Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.99487 7.94389L7.94462 2.99414L9.00528 4.0548L4.05553 9.00455L2.99487 7.94389Z" class="svg-fg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" class="svg-bg"/>
  <path d="M4.60913 5.73437L5.73413 4.60937L11.391 10.2662L10.266 11.3912L4.60913 5.73437Z" class="svg-fg"/>
  <path d="M4.60913 10.2662L10.266 4.60938L11.391 5.73437L5.73413 11.3912L4.60913 10.2662Z" class="svg-fg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" class="svg-bg"/>
  <path d="M7.36085 8.8613L8.86085 7.36131L16.639 15.1395L15.139 16.6395L7.36085 8.8613Z" class="svg-fg"/>
  <path d="M7.36083 15.1395L15.139 7.36133L16.639 8.86132L8.86083 16.6395L7.36083 15.1395Z" class="svg-fg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16" cy="16" r="15" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7175 11.4045L11.4038 22.7182L9.28247 20.5969L20.5962 9.2832L22.7175 11.4045Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4038 9.2832L22.7175 20.5969L20.5962 22.7182L9.28247 11.4045L11.4038 9.2832Z" class="svg-fg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="32" cy="32" r="30" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M35.8926 31.9766L45.9613 21.9079L42.0729 18.0195L32.0042 28.0882L21.9389 18.023L18.0499 21.912L28.1151 31.9773L18.0312 42.0612L21.9197 45.9496L32.0035 35.8657L42.0915 45.9537L45.9806 42.0646L35.8926 31.9766Z" class="svg-fg"/>
</svg>
`;
/**
 * IconAlertsEwiErrorRound is a generated icon component.
 */
let IconAlertsEwiErrorRound = IconAlertsEwiErrorRound_1 = class IconAlertsEwiErrorRound extends IconBaseElement {
    render() {
        return html `${IconAlertsEwiErrorRound_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAlertsEwiErrorRound.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconAlertsEwiErrorRound = IconAlertsEwiErrorRound_1 = __decorate([
    customElement('zui-icon-alerts-ewi-error-round')
], IconAlertsEwiErrorRound);
export { IconAlertsEwiErrorRound };
